module.exports = __webpack_public_path__ + "img/foto_5.c544470d.png";